import { render } from "./LocalizedTextField.vue?vue&type=template&id=6b5cf659&scoped=true"
import script from "./LocalizedTextField.vue?vue&type=script&lang=js"
export * from "./LocalizedTextField.vue?vue&type=script&lang=js"

import "./LocalizedTextField.vue?vue&type=style&index=0&id=6b5cf659&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b5cf659"]])

export default __exports__